// extracted by mini-css-extract-plugin
var _1 = "checkbox-module_checkboxElement_xmh3d";
var _2 = "checkbox-module_checkboxLabelClass_FVbND";
var _3 = "checkbox-module_checkboxWrapper_ew_gr";
export { _1 as "checkboxElement", _2 as "checkboxLabelClass", _3 as "checkboxWrapper" }
